export default __webpack_public_path__ + "static/box-closed-f4747b0c198ea4aa707ad9469c85926e.svg";